import { useEffect, useState } from "react";
import { authStorage } from "../../../auth";
import { PS_URLS } from "../../../core";
import { useMessages } from "../../../ui/MessagesProvider";
import { PageLoading } from "../../../ui/Loading";
import { useHistory, useLocation } from "react-router-dom";
import { getLinkedVendors } from "../../integrations/energy-devices/energy-device-oems.client";

interface AuthProps {
    render?: () => JSX.Element;
    children?: JSX.Element;
}

export function ICP4AuthWrapper({render, children}: AuthProps): JSX.Element {
  const company = authStorage.getCompany();
  const companyId = company.id;
  const [hasSomeLinkedVendors, setHasSomeLinkedVendors] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(true);
  const {clear, error} = useMessages();
  const history = useHistory();

  const companyHasAlreadyBeenOnboarded = authStorage.getMaybeUser()?.company?.accessRequestAccepted;

  useEffect(() => {
      if (render && children) console.error("You shouldn't use render and children at the same time")
      else if (!render && !children) console.error("You should use render or children")
  }, [render, children])

  useEffect(() => {
      if(companyHasAlreadyBeenOnboarded) return;
      async function load() {
        setIsLoading(true);
        const linkedVendors = await getLinkedVendors(companyId);
        setHasSomeLinkedVendors(linkedVendors.length > 0);
        setIsLoading(false);
      }
      load().catch(e => error(e.message));
    }, [companyId, companyHasAlreadyBeenOnboarded]);
    
    useEffect(() => {
      if(isLoading) return;
      if (companyHasAlreadyBeenOnboarded) {
        return;
      } else if(hasSomeLinkedVendors){
        if(window.location.pathname === PS_URLS(companyId).icp4InterestRegistered() || window.location.pathname === PS_URLS(companyId).icp4VendorsIntegration()){
          return;
        } else {
          history.push(PS_URLS(companyId).icp4ProjectsConfiguration());
        }
      } else {
        history.push(PS_URLS(companyId).icp4VendorsIntegration());
      }
    }, [isLoading, companyHasAlreadyBeenOnboarded]);
    
    if(!companyHasAlreadyBeenOnboarded && isLoading){
      return <PageLoading />
    }

    return render ? render() : <>{children}</>;

}